export const DATA_HOOKS = {
    CLOSE_BTN: 'close-btn',
};
//# sourceMappingURL=constants.js.map